// extracted by mini-css-extract-plugin
export default {"footer":"Contact_footer__3X78a","a":"Contact_a__u9sv0","ul":"Contact_ul__l0OAO","li":"Contact_li__ubdIq","tel":"Contact_tel__hksPU","p":"Contact_p__N-KAg","div":"Contact_div__6PAsO"};